/* eslint-disable @typescript-eslint/naming-convention */
import { RenderingDetailsMeta } from "./RenderingDetails";
import { PresentationInfo } from "./SwiggyOneInfo";

export interface ExtraItem {
    type: string;
    data: ExtraItemData;
}

export interface LogoCtx {
    logo: string;
    text: string;
}

export interface ExtraItemData {
    nudge_type: string;
    cta: null;
    title: string;
    line_item_comms: LineItemComms;
    plan_details: PlanDetails;
    remove_plan_message: RemovePlanMessage;
    logo_ctx: LogoCtx | null;
    badge_info: null;
    footer_comms: null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
}

export interface LineItemComms {
    title: string;
    sub_title: string[];
    attribute_values: LineItemCommsAttributeValues;
}

export interface LineItemCommsAttributeValues {
    del_fee: string;
}

export interface PlanDetails {
    plan_id: number;
    type: string;
    program: string;
    name: string;
    base_price: number;
    final_price: number;
}

export type Title = {
    text: string;
    attribute_values?: Record<string, string>;
};
export interface RemovePlanMessage {
    title: Title | string;
    content: Content[];
}

export interface TGLogoCTX {
    text: string;
    logo: string;
    lottie?: string;
}

export interface PlanAttributeValues extends Record<string, string> {
    plan_info_text?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
}

export interface TGCTAs {
    link: string;
    type: string;
    text: string;
}

export enum HalfcardVariants {
    DEFAULT = "Default",
    NEW = "New",
}

export interface FrequencyCap {
    id: string;
    count: number | string;
}

export interface BullsEyeCardComms {
    logo_ctx: TGLogoCTX;
    subtitles: string[];
    attribute_values: PlanAttributeValues;
    ctas: TGCTAs[];
    note?: string;
}

export interface AttributeValues {
    [key: string]: string;
}

export interface Content {
    title: string;
    attribute_values?: AttributeValues;
    sub_title?: string;
    badge_info?: BadgeInfo;
}

export interface RemovePlanAttributeValues {
    plan_in_cart_savings: string;
    cart_total_plan_added: string;
    cart_total_plan_not_added: string;
    cart_total_diff_config: string;
}

export interface BadgeInfo {
    text: string;
}

export type IItem = ExtraItemData | PresentationInfo | RenderingDetailsMeta;
export type IUpdateItem = ExtraItemData | RenderingDetailsMeta;

export interface IExtraItemContext {
    updating: boolean;
    onUpdateItem: (args: IUpdateItem, type?: string, isOfferPackAdded?: boolean) => void;
    showHalfCard: IItem | boolean;
    onHalfCardClose: () => void;
    onHalfCardConfirm: (selectedOption: SelectedOption) => void;
}

export enum ExtraItemTypes {
    NUDGE_TYPE_AUTO_ADD = "NUDGE_TYPE_AUTO_ADD",
    NUDGE_TYPE_ONE_TAP = "NUDGE_TYPE_ONE_TAP",
}

export enum ButtonTitles {
    ADD = "ADD",
    REMOVE = "Remove",
    CONFIRM = "Confirm",
}

export enum SelectedOption {
    ADD = 0,
    REMOVE = 1,
}
